import { observer } from 'mobx-react';
import type { FC } from 'react';
import { declension } from '@utils/declension';

export interface CatalogSeoBlockProps {
  categoryTitle: string;
  totalProductsCount: number;
  minPrice: number;
}

const CatalogSeoBlock: FC<CatalogSeoBlockProps> = ({
  categoryTitle,
  totalProductsCount,
  minPrice
}) => (
  <div>
    <div>
      <div>
        <h2 className='mb-3 text-2xl allMd:text-xl'>
          Почему покупать {categoryTitle} в интернет-магазине Деликатеска
          выгодно?
        </h2>
      </div>
      <div>
        <p>
          ⭐️ {totalProductsCount}{' '}
          {declension(totalProductsCount, ['товар', 'товара', 'товаров'])} в
          каталоге
          <br />
          <br />
          🔥 Цена: от {`${minPrice}`?.replace('.', ',')} руб.
          <br />
          <br />
          ⚡️ Бесплатная доставка от 5000 руб.
          <br />
          <br />
          ♥️ Скидки и акции!
        </p>
      </div>
    </div>
  </div>
);

export default observer(CatalogSeoBlock);
